import Workflow from '../../pages/Workflow'
import SendMessage from '../../panels/SendMessage'

const workflowSteps = 1

export const sendMessageRoute = {
  path: '/sendMessage',
  name: 'sendMessage',
  component: Workflow,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: 'message',
      alias: '',
      component: SendMessage,
      meta: {
        requiresAuth: true,
        nextRoute: '/account?submit=true',
        backRoute: '/account',
        workflowSteps,
        currentStep: 1,
        navButton: 'Send Message',
        backNavLink: 'Back to Account',
        heading: 'Send Us a Message',
        inputValid: 'messageInputValid',
        beforeRouteLeave: workflowExit
      }
    }
  ]
}

function workflowExit (to, from, next, context) {
  if (to.query.submit) {
    context.setLoading()

    // then we know that the submit button was clicked vs a browser back
    context.$store.dispatch('messageSend')
      .then((result) => {
        console.log('Successfully sent the message')
        next()
      })
      .catch((reason) => {
        console.log('Sending message failed: %j', reason)
        context.clearLoading()
        next(false)
      })
  } else {
    context.$store.commit('clearMessage')
    next()
  }
}

export default sendMessageRoute



// WEBPACK FOOTER //
// ./src/router/workflows/sendMessage.js